/* Stroomkaart - translations: request flow (aanvraag, aanmelden, na_aanvraag)
   ============================================ */

/* eslint-disable @typescript-eslint/no-explicit-any */
export const nl = {
  /* ----- Aanvraag-pagina ----- */
  aanvraag: {
    title: 'Aanvraag indienen - Stroomkaart',
    eyebrow: 'Aanvraag indienen',
    h1:      'Vraag een stroompunt aan.',
    lede:    'Vul onderstaande gegevens in. We nemen binnen 1 werkdag contact op om de aanvraag te bevestigen en de praktische details af te stemmen.',
    section_project: 'Project',
    section_contact: 'Contactgegevens',
    section_point:   'Stroompunt en periode',
    label_project:   'Projectnaam',
    label_org:       'Organisatie',
    label_capacity:  'Max. stroom (A)',
    label_connection:'Type aansluiting',
    label_start:     'Startdatum',
    label_end:       'Einddatum',
    label_name:      'Naam contactpersoon',
    label_email:     'E-mailadres',
    label_phone:     'Telefoon',
    label_note:      'Toelichting',
    btn_submit:      'Verstuur aanvraag',
    btn_back:        'Terug naar kaart',
    wizard: {
      steps_aria:  'Voortgang aanvraag',
      steps_title: 'Aanvraag in 4 stappen',
      step1: { label: 'Het project',         sub: 'Wat ga je doen?' },
      step2: { label: 'De locatie',          sub: 'Welk stroompunt?' },
      step3: { label: 'Stroom & periode',    sub: 'Wat heb je nodig?' },
      step4: { label: 'Contact',             sub: 'Wie zijn jullie?' },
      panel1: {
        title: 'Vertel ons over je project.',
        sub:   'Hoe meer we weten, hoe sneller we de juiste capaciteit en aansluiting voor je kunnen reserveren.',
      },
      panel2: {
        title: 'Op welk stroompunt richt je je?',
        sub:   'Heb je al een specifiek punt in gedachten? Vul dan het ID in. Anders kunnen we op basis van adres meedenken.',
      },
      panel3: {
        title: 'Welke stroom en periode?',
        sub:   'Geen probleem als je nog niet zeker bent - geef een schatting, dan vullen we tijdens de check aan.',
      },
      panel4: {
        title: 'Wie kunnen we benaderen?',
        sub:   'We hebben één primair contactpersoon nodig. Voor de uitvoering kun je later extra contactpersonen koppelen aan dit project.',
      },
      project_label: 'Projectnaam',
      project_ph:    'Bijv. Renovatie Houthavens fase 2',
      org_label:     'Organisatie',
      org_ph:        'Bedrijfsnaam',
      type_label:    'Type project',
      type_default:  'Maak een keuze…',
      type_new:      'Nieuwbouw',
      type_renov:    'Renovatie',
      type_infra:    'Infraproject',
      type_temp:     'Tijdelijke voorziening',
      type_event:    'Evenement',
      type_evchg:    'Openbare laadpaal als bouwstroom',
      type_other:    'Anders',
      desc_label:    'Korte omschrijving (optioneel)',
      desc_ph:       'Wat ga je bouwen, voor welke partij, welke werkzaamheden zijn er gepland…',
      desc_help:     'Helpt ons om bij twijfel sneller mee te denken over de juiste capaciteit.',
      pointsearch_label:     'Zoek een stroompunt (optioneel)',
      pointsearch_ph:        'Naam, adres of plaats…',
      pointsearch_help_html: 'Of zoek visueel op de <a href="map.html" style="color:var(--sk-navy-700);text-decoration:underline;">kaart</a>.',
      pointsearch_min:       'Typ minstens 3 letters…',
      pointsearch_searching: 'Zoeken…',
      pointsearch_no_results:'Geen stroompunten gevonden.',
      selected_label:   'Gekozen stroompunten',
      selected_help:    'Voeg meer stroompunten toe als je project meer dan één station nodig heeft. Alle stations delen dezelfde periode + contactpersoon.',
      postal_label:  'Postcode bouwlocatie',
      postal_ph:     '1014 BG',
      city_label:    'Plaats',
      city_ph:       'Amsterdam',
      address_label: 'Straat & huisnummer',
      address_ph:    'Houthavenkade 12',
      cap_label:     'Max. stroom (A)',
      cap_default:   'Kies een waarde…',
      cap_other:     'Anders / weet ik nog niet',
      connector_label:   'Type aansluiting',
      connector_default: 'Kies een type…',
      connector_unknown: 'Onbekend',
      conn_label:    'Type aansluiting',
      conn_default:  'Kies een type…',
      conn_build:    'Bouwaansluiting',
      conn_ev:       'Openbare laadpaal',
      conn_shore:    'Walstroom',
      conn_event:    'Evenementen',
      start_label:   'Startdatum',
      end_label:     'Einddatum',
      est_label:     'Verwacht maandelijks verbruik (kWh, optioneel)',
      est_ph:        'Bijv. 8500',
      est_help:      'Een schatting helpt bij capaciteits&shy;planning en tariefkeuze.',
      name_label:    'Naam',
      name_ph:       'Voornaam Achternaam',
      role_label:    'Functie',
      role_ph:       'Bijv. Uitvoerder',
      email_label:   'E-mailadres',
      phone_label:   'Telefoon',
      phone_ph:      '06 …',
      kvk_label:     'KvK-nummer',
      kvk_ph:        '12345678',
      kvk_help:      'Niet verplicht in deze stap. Wel nodig voor activatie van het stroompunt.',
      next_steps_html: '<strong>Wat gebeurt er hierna?</strong> Je ontvangt direct een bevestigingsmail met je projectnummer. Binnen één werkdag krijg je een persoonlijk dashboard met de volledige checklist van benodigde documenten en machtigingen.',
      prev:          '← Vorige',
      next:          'Volgende stap →',
      submit:        'Aanvraag versturen →',
    },
  },
  /* ----- Aanmelden (eigenaren) ----- */
  aanmelden: {
    title:   'Aansluiting aanmelden - Stroomkaart',
    eyebrow: 'Voor overheidsorganisaties, bedrijven en netbeheerders',
    h1:      'Meld uw stroompunten aan op Stroomkaart.',
    lede_html: 'Twee manieren om uw beschikbare aansluitingen zichtbaar te maken voor heel Nederland: een simpele upload van uw bestaande aansluitingen-bestand, of de meetdienst van NRG Group voor automatische, actuele data. <strong>Gemeenten</strong> krijgen direct toegang tot een eigen beheerportaal voor het afhandelen van aanvragen. Voor <strong>bedrijven en netbeheerders</strong> handelt het Stroomkaart-team aanvragen in de eerste fase af op basis van vooraf afgestemde criteria; eigen portaaltoegang volgt op een later moment.',
    sec1: {
      eyebrow: 'Twee aanmeldroutes',
      title: 'Kies wat past bij uw situatie.',
      sub: 'U kunt klein beginnen met een eenmalige upload en later opschalen naar de NRG-meetdienst voor automatische data. Beide routes zijn gratis.'
    },
    sec2: {
      eyebrow: 'Optie 01 - Excel-upload',
      title: 'Bulk-upload via spreadsheet.',
      sub: 'De snelste manier om uw bestaande aansluitingen aan te melden. Vul ons sjabloon in, upload, klaar. Ideaal als startpunt, ook als u later wilt overstappen op de NRG-meetdienst.'
    },
    sec3: {
      eyebrow: 'Aanmelden',
      title: 'Start het aanmeld&shy;proces.',
      sub: 'Vul onderstaande gegevens in. We nemen binnen 1 werkdag contact op om de aanmelding af te ronden. Gemeenten activeren we direct in het beheerportaal; voor andere organisaties stemmen we de criteria af waarop het Stroomkaart-team aanvragen voor u afhandelt.'
    },
    sec4: {
      eyebrow: 'Veelgestelde vragen',
      title: 'Wat overheden vaak willen weten.'
    },
    opt1: {
      num: 'Optie 01',
      title: 'Simpele upload via Excel of CSV',
      effort: 'Inspanning: laag · Direct te starten',
      body: 'Heeft u uw aansluitingen in een spreadsheet of asset-systeem staan? Download ons sjabloon, vul het in en upload. Binnen een paar minuten staan al uw stroompunten op de kaart.',
      li1: 'Geen technische integratie nodig</li>\n<li>Sjabloon (.xlsx) met alle benodigde velden</li>\n<li>Bulk-upload van honderden punten in één keer</li>\n<li>Beschikbaarheid handmatig bijwerken in uw beheer&shy;portaal',
      cta: 'Direct aanmelden'
    },
    opt2: {
      num: 'Optie 02',
      title: 'Meetdienst via NRG Group',
      effort: 'Inspanning: zeer laag · Geautomatiseerd',
      body: 'Geen eigen monitoring? Geen probleem. NRG Group plaatst slimme meters op uw bestaande aansluitingen en levert de data rechtstreeks aan Stroomkaart aan, zodat status en verbruik altijd actueel zijn.',
      li1: 'Geen eigen IT-infrastructuur of monitoring nodig</li>\n<li>Slimme meter op bestaande aansluitkast</li>\n<li>Realtime beschikbaarheid op de kaart en in uw beheerportaal</li>\n<li>Inclusief storings&shy;monitoring en rapportage',
      cta: 'Meer over de meetdienst'
    },
    callout: '<strong>U bepaalt zelf de voorwaarden - wij regelen het beheer.</strong> Per aansluiting kiest u of die publiek zichtbaar is op de kaart, of alleen binnen uw eigen netwerk benaderbaar.',
    lede: 'Twee manieren om uw beschikbare aansluitingen zichtbaar te maken: een eenmalige upload van uw aansluitingenbestand, of een automatische ODA- of API-koppeling. Vul onderaan het formulier in - we nemen binnen één werkdag contact op.',
    form: {
      contact: 'Liever eerst een gesprek',
      count_1: '1 punt',
      count_21_50: '21 – 50 punten',
      count_2_5: '2 – 5 punten',
      count_50p: '50+ punten',
      count_6_20: '6 – 20 punten',
      count_default: 'Maak een keuze…',
      count_label: 'Aantal stroompunten dat u wilt aanmelden',
      count_unknown: 'Weet ik nog niet - wil eerst een gesprek',
      email_label: 'E-mailadres',
      existing_label: 'Heeft u al een eigen monitoringssysteem?',
      existing_ph: 'Bijv. Itron, Landis+Gyr, eigen platform, of: nee',
      method_combo: 'Combinatie van beide methoden',
      method_default: 'Maak een keuze…',
      method_excel: 'Optie 01 - Excel-upload',
      method_help: 'Geen zorg als u nog niet weet wat past - dat bepalen we samen tijdens het kennismakingsgesprek.',
      method_label: 'Voorkeursmethode (we kunnen meedenken)',
      method_meet: 'Optie 02 - Meetdienst via NRG Group',
      method_unknown: 'Nog onbekend - graag advies',
      name_label: 'Contactpersoon',
      name_ph: 'Voornaam Achternaam',
      note_label: 'Toelichting (optioneel)',
      note_ph: 'Wat voor stroompunten? Welke locaties? Bijzondere wensen of beperkingen?',
      org_label: 'Organisatie',
      org_ph: 'Bijv. Gemeente Amersfoort',
      orgtype_default: 'Maak een keuze…',
      orgtype_gov: 'Gemeente',
      orgtype_grid: 'Netbeheerder',
      orgtype_label: 'Type organisatie',
      orgtype_natgov: 'Rijksoverheid / agentschap',
      orgtype_other: 'Anders',
      orgtype_port: 'Havenbedrijf',
      orgtype_prov: 'Provincie',
      orgtype_realestate: 'Vastgoedbeheerder publieke sector',
      phone_label: 'Telefoon (optioneel)',
      role_label: 'Functie',
      role_ph: 'Bijv. Beleidsadviseur energie',
      submit: 'Aanmelding versturen →',
    },
  },
  /* ----- Na-aanvraag (bedankt-pagina) ----- */
  na_aanvraag: {
    title: 'Aanvraag ontvangen - Stroomkaart',
    eyebrow: 'Aanvraag ontvangen',
    h1: 'Bedankt voor uw aanvraag.',
    lede: 'We hebben uw aanvraag ontvangen en in behandeling genomen. Een bevestigingsmail is naar het opgegeven e-mailadres gestuurd. U hoort binnen 1-2 werkdagen van onze projectcoördinator.',
    confirm: {
      title: 'Aanvraag ontvangen - bedankt!',
      sub:   'Je ontvangt binnen 5 minuten een bevestigingsmail op het opgegeven adres. Bewaar je projectnummer goed.',
    },
    progress: {
      label: 'Voortgang',
      count: 'Fase 2 van 5 · 1 van 5 documenten compleet',
    },
    phase1: {
      title:     'Aanvraag ontvangen',
      when:      'Vandaag · 14:32',
      body_html: 'We hebben je aanvraag voor stroompunt <strong style="color: var(--sk-navy-800);">Houthavens (AMS-001)</strong> goed ontvangen. Je krijgt direct een ontvangstbevestiging per mail.',
    },
    phase2: {
      title: 'Documenten aanleveren',
      when:  'Deadline: binnen 5 werkdagen',
      body:  'Voor de capaciteitscheck en juridische vastlegging hebben we de volgende documenten nodig. Lever ze allemaal aan vóór de deadline om vertraging te voorkomen.',
    },
    phase3: {
      title: 'Capaciteitscheck',
      when:  'Volgt automatisch · 1 werkdag',
      body:  'Onze technische experts controleren of het gevraagde vermogen op het gekozen stroompunt beschikbaar is en of de aansluitschets klopt. Bij twijfel nemen we contact op.',
    },
    phase4: {
      title: 'Activatie & aansluiting',
      when:  'Op afgesproken startdatum',
      body:  'Op de afgesproken datum is je stroompunt operationeel. Je ontvangt 24 uur vooraf een mail met de toegangscode of pas-info en het noodnummer voor onverhoopte storingen.',
    },
    phase5: {
      title: 'In gebruik',
      when:  'Lopend tijdens project',
      body:  'Je verbruik wordt automatisch geregistreerd. Maandelijks ontvang je een overzicht. Verlengen of eerder afsluiten kan altijd via je dashboard.',
    },
    doc: {
      view:     'Bekijken',
      download: 'Download formulier',
      upload:   'Uploaden',
    },
    doc1: {
      title: 'KvK-uittreksel (≤ 30 dagen oud)',
      meta:  'Geüpload op 25 april · pdf, 124 KB',
    },
    doc2: {
      title: 'Machtigingsformulier',
      meta:  'Standaard SK-machtiging, eenmalig invullen en ondertekenen.',
    },
    doc3: {
      title: 'Bouwvergunning (omgevings&shy;vergunning)',
      meta:  'Of een schriftelijke bevestiging van de gemeente bij vergunningvrije werkzaamheden.',
    },
    doc4: {
      title: 'Aansluitschets / situatie&shy;tekening',
      meta:  'Plattegrond met kabeltracé van het stroompunt naar je bouwkast.',
    },
    doc5: {
      title: 'Projectplanning',
      meta:  'Korte planning met start, eind en piekmomenten in verbruik.',
    },
    summary: {
      title:          'Aanvraag samenvatting',
      label_project:  'Project',
      val_project:    'Renovatie Houthavens fase 2',
      label_point:    'Stroompunt',
      label_location: 'Locatie',
      label_capacity: 'Max. stroom',
      label_type:     'Type',
      val_type:       'Bouw&shy;aansluiting',
      label_start:    'Startdatum',
      val_start:      '15 mei 2026',
      label_end:      'Einddatum',
      val_end:        '30 nov 2026',
    },
    contact_card: {
      title: 'Vragen tussendoor?',
      sub:   'Onze projectcoördinator denkt graag mee. Bereikbaar op werkdagen tussen 8:00 en 17:30.',
    },
    actions: {
      title:       'Acties',
      back_to_map: '← Terug naar de kaart',
      cancel:      'Aanvraag annuleren',
    },
  },
};

export const en = {
  aanvraag: {
    title: 'Submit request - Stroomkaart',
    eyebrow: 'Submit request',
    h1:      'Request a power point.',
    lede:    'Fill in the details below. We will contact you within 1 business day to confirm the request and discuss the practical details.',
    section_project: 'Project',
    section_contact: 'Contact details',
    section_point:   'Power point and period',
    label_project:   'Project name',
    label_org:       'Organization',
    label_capacity:  'Max. current (A)',
    label_connection:'Connection type',
    label_start:     'Start date',
    label_end:       'End date',
    label_name:      'Contact name',
    label_email:     'Email address',
    label_phone:     'Phone',
    label_note:      'Notes',
    btn_submit:      'Submit request',
    btn_back:        'Back to map',
    wizard: {
      steps_aria:  'Request progress',
      steps_title: 'Request in 4 steps',
      step1: { label: 'The project',         sub: 'What are you doing?' },
      step2: { label: 'The location',        sub: 'Which power point?' },
      step3: { label: 'Current & period',    sub: 'What do you need?' },
      step4: { label: 'Contact',             sub: 'Who are you?' },
      panel1: {
        title: 'Tell us about your project.',
        sub:   'The more we know, the faster we can reserve the right capacity and connection for you.',
      },
      panel2: {
        title: 'Which power point are you targeting?',
        sub:   'Do you already have a specific point in mind? Enter its ID. Otherwise we can help based on the address.',
      },
      panel3: {
        title: 'Which current and period?',
        sub:   'No problem if you are not sure yet - give an estimate and we will refine it during the check.',
      },
      panel4: {
        title: 'Who can we contact?',
        sub:   'We need one primary contact person. You can add additional contacts to this project later for the execution phase.',
      },
      project_label: 'Project name',
      project_ph:    'E.g. Houthavens renovation phase 2',
      org_label:     'Organisation',
      org_ph:        'Company name',
      type_label:    'Project type',
      type_default:  'Make a selection…',
      type_new:      'New construction',
      type_renov:    'Renovation',
      type_infra:    'Infrastructure project',
      type_temp:     'Temporary installation',
      type_event:    'Event',
      type_evchg:    'Public EV charger as construction power',
      type_other:    'Other',
      desc_label:    'Short description (optional)',
      desc_ph:       'What will you be building, for whom, which works are planned…',
      desc_help:     'Helps us advise on the right capacity when there is doubt.',
      pointsearch_label:     'Search for a power point (optional)',
      pointsearch_ph:        'Name, address or city…',
      pointsearch_help_html: 'Or browse visually on the <a href="map.html" style="color:var(--sk-navy-700);text-decoration:underline;">map</a>.',
      pointsearch_min:       'Type at least 3 letters…',
      pointsearch_searching: 'Searching…',
      pointsearch_no_results:'No power points found.',
      selected_label:   'Selected power points',
      selected_help:    'Add more power points if your project needs more than one station. They all share the same period + contact.',
      postal_label:  'Postal code (construction site)',
      postal_ph:     '1014 BG',
      city_label:    'City',
      city_ph:       'Amsterdam',
      address_label: 'Street & number',
      address_ph:    'Houthavenkade 12',
      cap_label:     'Max. current (A)',
      cap_default:   'Choose a value…',
      cap_other:     'Other / not sure yet',
      connector_label:   'Connection type',
      connector_default: 'Choose a type…',
      connector_unknown: 'Unknown',
      conn_label:    'Connection type',
      conn_default:  'Choose a type…',
      conn_build:    'Construction connection',
      conn_ev:       'Public EV charger',
      conn_shore:    'Shore power',
      conn_event:    'Events',
      start_label:   'Start date',
      end_label:     'End date',
      est_label:     'Expected monthly consumption (kWh, optional)',
      est_ph:        'E.g. 8500',
      est_help:      'An estimate helps with capacity planning and tariff selection.',
      name_label:    'Name',
      name_ph:       'First name Last name',
      role_label:    'Role',
      role_ph:       'E.g. Site manager',
      email_label:   'Email address',
      phone_label:   'Phone',
      phone_ph:      '+44 …',
      kvk_label:     'Chamber of Commerce number',
      kvk_ph:        '12345678',
      kvk_help:      'Not required at this step. Will be needed to activate the power point.',
      next_steps_html: '<strong>What happens next?</strong> You will immediately receive a confirmation email with your project number. Within one business day you get a personal dashboard with the full checklist of required documents and authorisations.',
      prev:          '← Previous',
      next:          'Next step →',
      submit:        'Submit request →',
    },
  },
  aanmelden: {
    title:   'Register a connection - Stroomkaart',
    eyebrow: 'For government, businesses and grid operators',
    h1:      'Register your power points on Stroomkaart.',
    lede_html: 'Two ways to make your available connections visible across the Netherlands: a simple upload of your existing connections file, or NRG Group\'s metering service for automatic, up-to-date data. <strong>Municipalities</strong> get direct access to their own admin portal for handling requests. For <strong>businesses and grid operators</strong> the Stroomkaart team handles requests in phase 1 based on agreed criteria; own portal access follows at a later stage.',
    sec1: {
      eyebrow: 'Two paths',
      title: 'Two ways to register your power points.',
      sub: 'Whether you want to start small with an export of your existing connections file, or set up a fully automated metering link directly with your grid connection(s).'
    },
    sec2: {
      eyebrow: 'Option 01 - Excel upload',
      title: 'Bulk upload via spreadsheet.',
      sub: 'The fastest way to register your existing connections. Fill in our template, upload, done. Ideal as a starting point, even if you want to switch to the automated metering service later.'
    },
    sec3: {
      eyebrow: 'Register',
      title: 'Start the registration process.',
      sub: 'Fill in the details below. We will contact you within 1 business day to complete the registration. We activate municipalities directly in the admin portal; for other organisations we agree on the criteria by which the Stroomkaart team will handle requests on your behalf.'
    },
    sec4: {
      eyebrow: 'Frequently asked questions',
      title: 'What governments often want to know.'
    },
    opt1: {
      num: 'Option 01',
      title: 'One-off upload',
      effort: 'Effort: medium - Available right away',
      body: 'Already have your connections in a spreadsheet or asset system? Send us an export of your existing connections file and we will process it for you. Within a few business days your connections appear on the map.',
      li1: 'Suitable for organisations without real-time metering data',
      cta: 'Register directly'
    },
    opt2: {
      num: 'Option 02',
      title: 'Automated ODA or API link',
      effort: 'Effort: low - Automated',
      body: 'For organisations that want to show continuously up-to-date data: NRG Group links your small-consumer connections via ODA and your large-consumer meter via a direct API link. Available capacity and status are shown on the map automatically and in real time, without needing your own monitoring or IT infrastructure.',
      li1: 'Real-time status on the map - management and requests are handled by the Stroomkaart team.',
      cta: 'More info on nrggroup.nl'
    },
    callout: '<strong>You set the conditions - we handle the management.</strong> Per connection you decide whether it is publicly visible on the map, or only accessible within your own network.',
    lede: 'Two ways to make your available connections visible: a one-off upload of your connections file, or an automated ODA or API link. Fill in the form below - we will be in touch within one business day.',
    form: {
      contact: 'Prefer a conversation first',
      count_1: '1 point',
      count_21_50: '21 – 50 points',
      count_2_5: '2 – 5 points',
      count_50p: '50+ points',
      count_6_20: '6 – 20 points',
      count_default: 'Make a selection…',
      count_label: 'Number of power points you want to register',
      count_unknown: 'Not sure yet - prefer a conversation first',
      email_label: 'Email address',
      existing_label: 'Do you already have your own monitoring system?',
      existing_ph: 'E.g. Itron, Landis+Gyr, own platform, or: no',
      method_combo: 'Combination of both methods',
      method_default: 'Make a selection…',
      method_excel: 'Option 01 - Excel upload',
      method_help: 'No worries if you do not know yet what fits - we will determine that together during the intake conversation.',
      method_label: 'Preferred method (we can advise)',
      method_meet: 'Option 02 - NRG Group metering service',
      method_unknown: 'Unknown - happy to receive advice',
      name_label: 'Contact person',
      name_ph: 'First name Last name',
      note_label: 'Notes (optional)',
      note_ph: 'What kind of power points? Which locations? Any special requirements or constraints?',
      org_label: 'Organisation',
      org_ph: 'E.g. City of Amersfoort',
      orgtype_default: 'Make a selection…',
      orgtype_gov: 'Municipality',
      orgtype_grid: 'Grid operator',
      orgtype_label: 'Type of organisation',
      orgtype_natgov: 'National government / agency',
      orgtype_other: 'Other',
      orgtype_port: 'Port authority',
      orgtype_prov: 'Province',
      orgtype_realestate: 'Public-sector real estate manager',
      phone_label: 'Phone (optional)',
      role_label: 'Role',
      role_ph: 'E.g. Energy policy advisor',
      submit: 'Submit registration →',
    },
  },
  na_aanvraag: {
    title: 'Request received - Stroomkaart',
    eyebrow: 'Request received',
    h1: 'Thank you for your request.',
    lede: 'We have received your request and are processing it. A confirmation email has been sent to the email address you provided. You will hear from our project coordinator within 1-2 business days.',
    confirm: {
      title: 'Request received - thank you!',
      sub:   'You will receive a confirmation email within 5 minutes at the address you provided. Keep your project number safe.',
    },
    progress: {
      label: 'Progress',
      count: 'Phase 2 of 5 · 1 of 5 documents complete',
    },
    phase1: {
      title:     'Request received',
      when:      'Today · 14:32',
      body_html: 'We have received your request for power point <strong style="color: var(--sk-navy-800);">Houthavens (AMS-001)</strong>. You will get an acknowledgement email right away.',
    },
    phase2: {
      title: 'Provide documents',
      when:  'Deadline: within 5 business days',
      body:  'For the capacity check and legal record we need the following documents. Provide them all before the deadline to avoid delay.',
    },
    phase3: {
      title: 'Capacity check',
      when:  'Follows automatically · 1 business day',
      body:  'Our technical experts verify whether the requested capacity is available at the chosen power point and whether the connection drawing is correct. We contact you if anything is unclear.',
    },
    phase4: {
      title: 'Activation & connection',
      when:  'On agreed start date',
      body:  'On the agreed date your power point is operational. You receive an email 24 hours in advance with the access code or pass info plus the emergency number for unexpected faults.',
    },
    phase5: {
      title: 'In use',
      when:  'Ongoing during project',
      body:  'Your consumption is automatically recorded. Each month you receive a summary. You can extend or close early at any time via your dashboard.',
    },
    doc: {
      view:     'View',
      download: 'Download form',
      upload:   'Upload',
    },
    doc1: {
      title: 'Chamber of Commerce extract (≤ 30 days old)',
      meta:  'Uploaded on 25 April · pdf, 124 KB',
    },
    doc2: {
      title: 'Authorisation form',
      meta:  'Standard SK authorisation, one-off fill and sign.',
    },
    doc3: {
      title: 'Construction permit (environmental permit)',
      meta:  'Or written confirmation from the municipality if no permit is required.',
    },
    doc4: {
      title: 'Connection drawing / site plan',
      meta:  'Plan with the cable route from the power point to your distribution cabinet.',
    },
    doc5: {
      title: 'Project planning',
      meta:  'Short schedule with start, end and consumption peaks.',
    },
    summary: {
      title:          'Request summary',
      label_project:  'Project',
      val_project:    'Houthavens renovation phase 2',
      label_point:    'Power point',
      label_location: 'Location',
      label_capacity: 'Max. current',
      label_type:     'Type',
      val_type:       'Construction&shy;connection',
      label_start:    'Start date',
      val_start:      '15 May 2026',
      label_end:      'End date',
      val_end:        '30 Nov 2026',
    },
    contact_card: {
      title: 'Questions in the meantime?',
      sub:   'Our project coordinator is happy to help. Available on business days between 8:00 and 17:30.',
    },
    actions: {
      title:       'Actions',
      back_to_map: '← Back to the map',
      cancel:      'Cancel request',
    },
  },
};
